import { useState, useEffect, forwardRef, useImperativeHandle, useRef } from 'react';
import './tableOne.css';
//import TableOneEditModal from '../../../../../content/TableOneEditModal';
import ContentMenuDropDown from '../TableSortingMenuActionBtn/Utils/ContentMenuDropDown';
//../components\2_MiddleSection\Parts\ContentContainer\Parts\TableSortingMenuActionBtn\Utils\ContentMenuDropDown.js

function TableOne(props, ref) {

	const [orders, setOrders] = useState([]);
	const [filterDropdownIs, setFilterDropdownIs] = useState(false);
	//const [filterSelected, setFilterSelected] = useState({status:[]});
	const [pageNumber, setPageNumber] = useState(1);
	const [orderUrl, setOrderUrl] = useState({ limit: "30", orderby: "id", feild: ['status'], search: ['Created', 'Office', 'Vendor', 'Pickup', 'Transit', 'Submitted', 'Packing'], page: '' });
	let statusFilterMenu = useRef();

	useImperativeHandle(ref, () => {
		return {
			tableOneFetchOrders: (limit, sortby, feild, search) => fetchOrders(limit, sortby, feild, search),
			pageNumber: (num) => { setPageNumber(num) },
			tableOneRefresh: () => { fetchOrders(orderUrl.limit, orderUrl.orderby, orderUrl.feild, orderUrl.search, pageNumber) }
		}
	})

	const fetchOrders = async (limit = '30', orderby = 'id', feild = [], search = [], page=1) => {
		//url='http://arobaniworks.com/api/support/orders?&limit=30&page=1&orderby=id'
		
		// if(!page){
		// 	page = 1;
		// 	setPageNumber(1);
		// } 

		function urlBuilder() {
			const baseUrl = process.env.REACT_APP_BASE_URL+'/api/support/orders';
			const feildParam = [];
			const searchParam = [];
			
			for (let i = 0; i < feild.length; i++) {
				if (feild.length === 1) {
					feildParam.push('&feild[]=' + feild[i])
				} else {
					feildParam.push('&feild=' + feild[i])
				}
			}
			for (let i = 0; i < search.length; i++) {
				if (search.length === 1) {
					searchParam.push('&search[]=' + search[i])
				} else {
					searchParam.push('&search=' + search[i])
				}
			}
			const url = `${baseUrl}?&page=${page}&limit=${limit}&orderby=${orderby}${feild && feildParam.join("")}${search && searchParam.join("")}`;
			setOrderUrl({ limit, orderby, feild, search, page });
			return url;
		}

		try {
			props.spinner(true);
			const key = localStorage.getItem("loginToken");
			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");
			myHeaders.append("Authorization", key);

			const requestOptions = {
				method: "GET",
				headers: myHeaders,
				redirect: "manual"
			};

			await fetch(urlBuilder(), requestOptions)
				.then((response) => response.json())
				.then((result) => {
					//console.log(orderUrl)

					if (result.success === 0) {
						props.updateIsLoggedIn(false);
					} else {
						const data = result.data;
						if (data.length > 0) {
							setOrders(data);
							props.footerCounts(
								{
									page: result.pagination.page,
									offset: result.pagination.offset,
									limit: result.pagination.limit,
									pageRecords: result.pagination.pageRecords,
									totalRecords: result.pagination.totalRecords,
									totalPages: result.pagination.totalPages
								}
							);
							props.spinner(false);
						}else{
							setOrders(data);
						}
						props.spinner(false);
					}
				})

		}
		catch (error) {
			console.log(error);
		}


	}

	// //Default Table Content On Load.
	// useEffect(() => {
	// 	fetchOrders(30, 'id', [], []);
	// }, []);

	useEffect(() => {
		//const baseUrl = 'http://arobaniworks.com/api/support/orders' ;
		//let counter = 1 ;
		fetchOrders(orderUrl.limit, orderUrl.orderby, orderUrl.feild, orderUrl.search, pageNumber);
		//counter++
		
		function statusFilterDropDownAction() {
			let statusDropDownMenu = (e) => {
				if(statusFilterMenu.current !== null){	
					if(!statusFilterMenu.current.contains(e.target)){
						setFilterDropdownIs(false)
					}
				}	
			}
			document.addEventListener("mousedown", statusDropDownMenu);
			return () => { document.removeEventListener("mousedown", statusDropDownMenu); }
		}
		statusFilterDropDownAction();

		async function trackingStatus(waybill='13975010011561'){
			const myHeaders = new Headers();
			myHeaders.append("Authorization", "Token e79993953f28ce1838974e6180cbc992da15c03e");

			const requestOptions = {
			method: "GET",
			headers: myHeaders,
			redirect: "follow"
			};

			fetch("https://track.delhivery.com/api/v1/packages/json/?waybill=13975010011561", requestOptions)
			.then((response) => response.text())
			.then((result) => console.log(result))
			.catch((error) => console.error(error));
		}
		//trackingStatus()
		//console.log();
	}, [pageNumber]);


	const onClicEditModalkHandler = (event) => {
		//console.log(event.target.parentElement.parentElement)
		// <TableOneEditModal editShowModal = {event.target.parentElement.parentElement}/>
		//props.tableOneEvent(event.target.parentElement.parentElement)
		
		const id = event.target.parentElement.parentElement.id
		if(id){
			const rowData = orders.filter(order => order.id == id)
			props.tableOneEvent(rowData[0])
			props.showHideModal(true)
		}
		//console.log('inside onclick funcion')
		//console.log(id)
	}

	const downloadFileHandler = (id, fileName) => {
		if (id === 'downloadFile1') {
			window.location.href = process.env.REACT_APP_BASE_URL+"/api/support/downloads/" + fileName;
		}
		if (id === 'downloadFile2') {
			window.location.href = process.env.REACT_APP_BASE_URL+"/api/support/downloads/" + fileName;
		}
		if (id === 'downloadFile3') {
			window.location.href = process.env.REACT_APP_BASE_URL+"/api/support/downloads/" + fileName;
		}
	}

	const filterDropdown = () => {
		//const [isChecked, setIsChecked] = useState(false);
		const selectedOptions = [];
		//const selectedOptionsobj = {};

		// handleCheckboxMenuOpen
		if (filterDropdownIs) {
			orderUrl.search.some(v => v === 'Created') && selectedOptions.push('Created');
			orderUrl.search.some(v => v === 'Office') && selectedOptions.push('Office');
			orderUrl.search.some(v => v === 'Vendor') && selectedOptions.push('Vendor');
			orderUrl.search.some(v => v === 'Pickup') && selectedOptions.push('Pickup');
			orderUrl.search.some(v => v === 'Submitted') && selectedOptions.push('Submitted');
			orderUrl.search.some(v => v === 'Transit') && selectedOptions.push('Transit');
			orderUrl.search.some(v => v === 'Completed') && selectedOptions.push('Completed');
			orderUrl.search.some(v => v === 'Packing') && selectedOptions.push('Packing');
		}

		const handleCheckboxChange = (event) => {
			if (event.target.checked) {
				selectedOptions.push(event.target.nextElementSibling.innerText)
			} else {
				selectedOptions.map((value, index) => { value == event.target.nextElementSibling.innerText && selectedOptions.splice(index, 1) })
			}
			//setFilterSelected({status:selectedOptions})
		}

		const handleApplyButon = () => {
			// const urlArr = [];
			// for (let i=0; i<selectedOptions.length; i++ ){
			// 	urlArr.push( '&search[]='+selectedOptions[i] )
			// }
			if (selectedOptions.length > 0) {
				//console.log(urlArr.join(""))
				fetchOrders(30, 'id', ['status'], selectedOptions)
				// fetchOrders('http://arobaniworks.com/api/support/orders?page=1&limit=80&feild[]=status'+urlArr.join(""))
				setOrderUrl(() => ({ ...orderUrl, ['search']: selectedOptions }))
				setTimeout(() => setFilterDropdownIs(false), 500)
			} else {
				alert('Please Select Once Option')
			}

		}
		return (

			<div style={{ left: '-12rem', top: '30px', zIndex: '3' }} className="menuDropDown" >
				<div className="menuDropDown-header">Filter by status {/*<span onClick={() => setFilterDropdownis(false)} style={{ float: 'right', paddingRight: '10px', color: 'red', fontWeight: '900' }}>X</span>*/}</div>
				<div className="menuDropDown-body">
					<div onChange={() => selectedOptions.push(...['Created','Office','Vendor','Submitted','Packing','Pickup','Transit'])}>
						<input id="c1-23" type="checkbox" defaultChecked={orderUrl.search.some(v => v === 'All')} />
						<label htmlFor="c1-23">All</label>
					</div>
					<div onChange={handleCheckboxChange}>
						<input type="checkbox" defaultChecked={orderUrl.search.some(v => v === 'Created')} />
						<label >Created</label>
					</div>
					<div onChange={handleCheckboxChange}>
						<input id="c1-14" type="checkbox" defaultChecked={orderUrl.search.some(v => v === 'Office')} />
						<label htmlFor="c1-14">Office</label>
					</div>
					<div onChange={handleCheckboxChange}>
						<input id="c1-15" type="checkbox" defaultChecked={orderUrl.search.some(v => v === 'Vendor')} />
						<label htmlFor="c1-15">Vendor</label>
					</div>
					<div onChange={handleCheckboxChange}>
						<input id="c1-17" type="checkbox" defaultChecked={orderUrl.search.some(v => v === 'Submitted')} />
						<label htmlFor="c1-17">Submitted</label>
					</div>
					<div onChange={handleCheckboxChange}>
						<input id="c1-21" type="checkbox" defaultChecked={orderUrl.search.some(v => v === 'Packing')} />
						<label htmlFor="c1-21">Packing</label>
					</div>
					<div onChange={handleCheckboxChange}>
						<input id="c1-16" type="checkbox" defaultChecked={orderUrl.search.some(v => v === 'Pickup')} />
						<label htmlFor="c1-16">Pickup</label>
					</div>
					{/* <div onChange={handleCheckboxChange}>
						<input id="c1-18" type="checkbox" />
						<label htmlFor="c1-18">Vendor</label>
					</div> */}
					<div onChange={handleCheckboxChange}>
						<input id="c1-19" type="checkbox" defaultChecked={orderUrl.search.some(v => v === 'Transit')} />
						<label htmlFor="c1-19">Transit</label>
					</div>

					{/* <div onChange={handleCheckboxChange}>
						<input id="c1-20" type="checkbox" defaultChecked={orderUrl.search.some(v => v=='Completed')} />
						<label htmlFor="c1-20">Completed</label>
					</div> */}
				</div>

				<div className="menuDropDown-footer"><button onClick={() => handleApplyButon()} id="menuDropDown-footerbtn">Apply</button></div>
			</div>
		)
	}

	const statusColorHandler = (status) => {
		if(status=='Created'){return 'statusBlue'}
		if(status=='Office'){return 'statusYellow'}
		if(status=='Vendor'){return 'statusRed'}
		if(status=='Submitted'){return 'statusGreen'}
		if(status=='Closed'){return 'statusGreen'}
		if(status=='Transit'){return 'statusAqua'}
		
	}
	//console.log('load count')

	return (
		<div className="content-table-box">
			<table>
				<thead>
					<tr>
						<th className='tableCheckBox menuDropDown-body'><input type="checkbox" /></th>
						<th>id</th>
						<th>Date</th>
						{/* <th>business_name</th> */}
						<th>Company Name</th>
						<th>Customer Name</th>
						{/* <th>customer_address</th> */}
						{/* <th>Order No</th> */}
						<th>Cus Order No</th>
						<th>State</th>
						<th>Vendor</th>
						<th>Stamp Value</th>
						<th>Stamp Qty</th>
						<th>In Cus Name</th>

						<th>Notary</th>
						<th>Bdated</th>
						<th>Certificate</th>
						<th>Scan</th>
						<th>Ship</th>
						<th>Copies</th>
						<th style={{position: 'relative'}} ref={statusFilterMenu} onClick={() => setFilterDropdownIs(true)}>Status<span style={{ color: 'red' }}> &#11015;</span>{filterDropdownIs && filterDropdown()}</th>
						<th>Documents</th>
						<th>Shiplabel</th>
						<th>Tracking Id</th>
						<th>Print Qty</th>
						<th>Scan Qty</th>
						<th>Stamp No</th>
						{/* <th>Stmp Buy Cost</th> */}
						<th>Vendor Note</th>
						<th>scan Doc</th>
					</tr>
				</thead>

				<tbody>

					{/* <tr>
						<td className='tableCheckBox menuDropDown-body'><input type="checkbox" /></td>
						<td>{ } </td>
						<td>USD</td>
						<td><span className='statusFlag statusGreen'>Succeeded </span></td>
						<td>Visa...1755</td>
						<td>Subscription Created</td>
						<td>sumanto@gmail.com</td>
						<td>Aug 25 20204</td>
						<td>--</td>
						<td>...</td>

					</tr> */}

					{
						orders.map((givenOrders, i) => {
							const { bdated, business_name, company_name, copies, created_at, created_by, customer_address, customer_name, date, documents, id, in_cus_name, in_cus_add, notary, certificate, order_no, cust_order_no, print_qty, scan, scan_doc, scan_qty, ship, ship_name, ship_phone, ship_address, shiplabel, stamp_no, stamp_qty, stamp_value, state, status, stmp_buy_cost, tracking_id, updated_at, updated_by, vendor, vendor_note, paid_amount
							} = givenOrders;

							return (
								<tr id={id} key={i}>
									<td className='tableCheckBox menuDropDown-body'><input type="checkbox" /></td>
									<td>{id}</td>
									<td>{new Date(date).getDate() + "-" + new Date(date).toLocaleString('default', { month: 'short' }) + "-" + new Date(date).toLocaleString('default', { year: '2-digit' })}</td>
									{/* <td>{business_name}</td> */}
									<td>{company_name}</td>
									<td>{customer_name}</td>
									{/* <td>{customer_address}</td> */}
									{/* <td>{order_no}</td> */}
									<td>{cust_order_no}</td>
									<td>{state}</td>
									<td>{vendor}</td>
									<td>{stamp_value}</td>
									<td>{stamp_qty}</td>
									<td>{in_cus_name !== "" ? "✔" : "-"}</td>

									<td>{notary === 1 ? "✔" : "-"}</td>
									<td>{bdated === "" ? "-" : new Date(bdated).getDate() + "-" + new Date(bdated).toLocaleString('default', { month: 'short' }) + "-" + new Date(bdated).toLocaleString('default', { year: '2-digit' })}</td>
									<td>{certificate === 1 ? "✔" : "-"}</td>
									<td>{scan === 1 ? "✔" : "-"}</td>
									<td>{ship === 0 ? "-" : ship==1?<span style={{color:'#4c2177'}} className="material-symbols-outlined">delivery_truck_speed</span>:<span style={{color:'blue'}} className="material-symbols-outlined">moped</span>}</td>
									<td style={{color:'red',fontSize:'13px',fontWeight:'800'}} >{copies<2 ? "" :copies}</td>
									<td><span className={'statusFlag '+ statusColorHandler(status)}>{status}</span></td>
									<td>
										{documents.split("/")[0] ?
											<span style={documents.split("/")[0].split(".")[1]==="pdf"?{color:'red'}:{color:'blue'}} className='tooltip'>
												<span id="downloadFile1" className="material-symbols-outlined" onClick={({ target }) => downloadFileHandler(target.id, documents.split("/")[0])}>file_save</span>
												{/* <span id="downloadFile1" onClick={({ target }) => downloadFileHandler(target.id, documents.split("/")[0])}><img src={require('../../../../../../../src/images/icon/pdf-micro.png' )} /></span> */}
												<span className='tooltiptext'>{documents.split("/")[0]}</span>
											</span> : <span></span>}
										{documents.split("/")[1] ?
											<span style={documents.split("/")[1].split(".")[1]==="pdf"?{color:'red'}:{color:'blue'}} className='tooltip'>
												<span id="downloadFile2" className="material-symbols-outlined" onClick={({ target }) => downloadFileHandler(target.id, documents.split("/")[1])}>file_save</span>
												<span className='tooltiptext'>{documents.split("/")[1]}</span>
											</span> : <span></span>}
										{documents.split("/")[2] ?
											<span style={documents.split("/")[2].split(".")[1]==="pdf"?{color:'red'}:{color:'blue'}} className='tooltip'>
												<span id="downloadFile3" className="material-symbols-outlined" onClick={({ target }) => downloadFileHandler(target.id, documents.split("/")[2])}>file_save</span>
												<span className='tooltiptext'>{documents.split("/")[2]}</span>
											</span> : <span></span>}
									</td>
									<td>{shiplabel.split("/")[0] ?
											<span style={shiplabel.split("/")[0].split(".")[1]==="pdf"?{color:'red'}:{color:'blue'}} className='tooltip'>
												<span id="downloadFile1" className="material-symbols-outlined" onClick={({ target }) => downloadFileHandler(target.id, shiplabel.split("/")[0])}>file_save</span>
												<span className='tooltiptext'>{shiplabel.split("/")[0]}</span>
											</span> : <span></span>}
									</td>
									<td>{tracking_id}</td>
									<td>{print_qty}</td>
									<td>{scan_qty}</td>
									<td>{stamp_no}</td>
									{/* <td>{stmp_buy_cost}</td> */}
									<td>{vendor_note}</td>
									<td style={{ color: 'red'}}>
										{scan_doc!==""?
											<span className='tooltip' onClick={() => {window.location.href = process.env.REACT_APP_BASE_URL+"/api/support/downloads/" + scan_doc}}>
												<span id="vendorScanFile1" className="material-symbols-outlined" >file_save</span>
												<span style={{right:'0'}} className='tooltiptext'>{scan_doc}</span>
											</span> : <span></span>}
									</td>
									{/* <td><span className='statusFlag statusGreen'>Succeeded </span></td> */}
									<td onClick={onClicEditModalkHandler} className='table-edit-icon'><span className="material-symbols-outlined">Edit</span></td>

								</tr>
							);
						})
					}


				</tbody>
			</table>
		</div>
	)
}



export default forwardRef(TableOne);